<template>
  <div>
    <div class="flex justify-between w-full">
      <div class="text-3xl mb-8">Veranstaltungen</div>
    </div>

    <BDataTable :client="eventsClient" :defaultFilter="{status: 'draft,live'}" :showFooter="true">
      <template v-slot:filter>
        <BFilterCheckbox name="status" :options="options" label="Status"></BFilterCheckbox>
      </template>

      <template v-slot:actions>
        <basic-button @click="$router.push({name: 'events.create'})" size="sm" leading-icon="plus">
          <span class="inline-block sm:hidden">Anlegen</span>
          <span class="hidden sm:inline-block">Veranstaltung anlegen</span>
        </basic-button>
      </template>

      <template v-slot:header>
        <div
          class="px-4 py-2 hidden md:grid grid-cols-12 grid-flow-col text-sm uppercase font-medium bg-gray-50 border-b border-gray-200"
        >
          <div class="col-span-4">Event</div>
          <div class="col-span-3">Datum</div>
          <div class="col-span-3">Verkauft</div>
          <div class="col-span-2">Status</div>
        </div>
      </template>

      <template v-slot:table="{ item }">
        <router-link
          :to="{name: 'events.dashboard', params: {id: item.id}}"
          class="px-4 py-2 grid grid-cols-12 items-center border-b border-gray-200 hover:bg-gray-50"
        >
          <div class="mr-4 col-span-7 md:col-span-4 truncate">
            <span class="font-medium">{{item.title}}</span>
          </div>
          <div class="col-span-12 sm:col-span-7 md:col-span-3">
            <span class="text-gray-700">{{formatDateTimeForHuman(item.start_date.local)}} Uhr</span>
          </div>
          <div class="hidden sm:block col-span-5 md:col-span-2">
            <event-availability-status-bar :sold="item.tickets_sold" :count="item.tickets_count"></event-availability-status-bar>
          </div>
          <div
            class="ml-auto col-span-5 col-start-8 row-start-1 md:ml-0 md:col-span-2 md:col-start-11"
          >
            <event-status-badge
              class="px-1 sm:px-4 text-xs sm:text-sm uppercase"
              :status="item.status"
            ></event-status-badge>
          </div>
        </router-link>
      </template>
    </BDataTable>
  </div>
</template>


<script>
import EventStatusBadge from "@/components/EventStatusBadge";
import EventAvailabilityStatusBar from "@/components/EventAvailabilityStatusBar";
import { BDataTable, BFilterCheckbox } from "@/components/BDataTable";

import eventsClient from "@/api/central/events";
import InteractsWithDates from "@/mixins/InteractsWithDates";

export default {
  components: {
    EventStatusBadge,
    EventAvailabilityStatusBar,
    BDataTable,
    BFilterCheckbox
  },

  mixins: [InteractsWithDates],

  data() {
    return {
      options: [
        {
          value: "live",
          label: "Veröffentlicht"
        },
        {
          value: "draft",
          label: "Entwurf"
        },
        {
          value: "completed",
          label: "Abgerechnet"
        },
        {
          value: "cancelled",
          label: "Abgesagt"
        }
      ]
    };
  },

  methods: {
    eventsClient({ page, resolve, filter }) {
      return eventsClient.index({ page, ...filter }).then(({ data }) => {
        resolve(data);
      });
    }
  }
};
</script>

